module.exports = __webpack_public_path__ + "img/table-departure-icon.3d3f004f.svg";